import React from 'react';
import { Link } from 'react-router-dom';
import { useReadingHistory } from '../../contexts/ReadingHistoryContext';

const RecentPoems: React.FC = () => {
  const { recentPoems } = useReadingHistory();

  if (recentPoems.length === 0) {
    return null;
  }

  return (
    <section className="recent-poems">
      <div className="recent-poems__grid">
        {recentPoems.slice(0, 6).map((poem) => (
          <Link
            key={poem.poemId}
            to={`/poem/${poem.poemId}`}
            className="recent-poems__card"
          >
            <div className="recent-poems__poem-name">{poem.poemName}</div>
            <div className="recent-poems__poet-name">{poem.poetName}</div>
          </Link>
        ))}
      </div>
    </section>
  );
};

export default RecentPoems;

